import React from "react";

import AttributeTagPicker from "./Components/AttributeTagPicker";

import { UserInterestAttributeSet } from "@/schemas/profile/attributes/UserInterestAttributeSet";
import type { AttributeValue } from "@/schemas/attribute/AttributeSet";

type Props = {
  onSelectionChange: (selectedValues: AttributeValue[]) => void;
  selectedValues: AttributeValue[];
};

function Interest({
  onSelectionChange,
  selectedValues,
}: Props): React.JSX.Element {
  return (
    <AttributeTagPicker
      attributeSet={UserInterestAttributeSet}
      onSelectionChange={onSelectionChange}
      selectedValues={selectedValues}
    />
  );
}

export default Interest;
